import { CSSObject } from '@emotion/react';
import { TDot, TDotContainer } from './Carousel.styles';

export const Dot = ({ selected }: TDot): CSSObject => ({
  bg: selected ? '#1A2F56' : 'blackAlpha.300',
});

export const DotContainer = ({
  numberOfSlides,
  index,
}: TDotContainer): CSSObject => ({
  bgGradient: 'linear(to-b, #1CD5FF, #00C0EB)',
  borderLeftRadius: index === 0 ? 'md' : '0',
  pl: index === 0 ? '0.5' : '0',
  borderRightRadius: index === numberOfSlides - 1 ? 'md' : '0',
  pr: index === numberOfSlides - 1 ? '0.5' : '0',
});
